module.exports = __webpack_public_path__ + "img/Frente-7-02 open.458eaeb6.jpg";